import { ref, reactive } from "vue";
import axios from "axios";
import router from "../../router/shop";
import { useToast } from "vue-toastification";
import { useRoute } from "vue-router";
export default function useOrders() {
  const order = reactive({});
  const returns = ref([]);
  const orders = ref([]);
  const loading = ref(true);
  const progressDialog = window.progressDialog;
  const errors = ref("");
  const errorModal = ref("");
  const exportData = reactive({ date: "", status: "" });
  const meta = reactive({});
  const toast = useToast();
  const route = useRoute();

  const getOrders = async (p = 1, filter = false) => {
    try {
      let query = "";
      if (filter) {
        const range = exportData.date;
        if (range.length) query += "&start_date=" + range[0];
        if (range.length > 1) query += "&end_date=" + range[1];
        if (exportData.status) query += "&status=" + exportData.status;
      } else if (p == 1) delete meta.current_page;
      errors.value = "";
      loading.value = true;
      let response = await axios.get("order" + "?page=" + p + query);
      loading.value = false;
      if (p == 1 || filter) orders.value = response.data.data;
      else orders.value.push(...response.data.data);
      Object.assign(meta, response.data.meta);
      meta.steps = response.data.steps;
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const getOrderReturns = async (p = 1) => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("order/return" + "?page=" + p);
      loading.value = false;
      if (p == 1) orders.value = response.data.data;
      else orders.value.push(...response.data.data);
      Object.assign(meta, response.data.meta);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const updateOrderReturn = async () => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.put("order/return/" + order.id);
      progressDialog.value = false;
      toast.success(response.data.message);
      router.push({ name: "orders" });
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const getOrder = async (returns = false) => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get(
        "order/" + route.params.id + (returns ? "?return=1" : ""),
      );
      Object.assign(order, response.data.data);
      if (!returns)
        Object.assign(meta, {
          steps: response.data.steps,
          can_return: response.data.can_return,
        });
      loading.value = false;
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const storeOrder = async (
    reserve = true,
    type = "",
    description = "",
    force = true,
  ) => {
    try {
      errorModal.value = "";
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.post("order", {
        reserve: reserve ? 1 : 0,
        type,
        force: force ? 1 : 0,
        description,
      });
      if (response.data.link) {
        const link = document.createElement("a");
        link.href = response.data.link;
        link.click();
      } else {
        progressDialog.value = false;
        toast.success(response.data.message);
        router.push({ name: "orders" });
      }
    } catch (e) {
      window.networkError(e);
      errorModal.value = e?.response?.data;
      progressDialog.value = false;
    }
  };

  const deleteOrder = async (id) => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.delete("order" + (id ? "/" + id : ""));
      progressDialog.value = false;
      toast.success(response.data.message);
      if (id) orders.value = orders.value.filter((item) => id != item.id);
      else getOrders();
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const getItemReturn = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("order/" + route.params.id + "/return");
      returns.value = response.data.data;
      loading.value = false;
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const storeItemReturn = async () => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.post("order/return", {
        order_number: route.params.id,
        items: returns.value.filter((item) => item.selected),
      });
      progressDialog.value = false;
      toast.success(response.data.message);
      router.push({ name: "order" });
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const exportOrder = async (order) => {
    try {
      progressDialog.value = true;
      let response = await axios.post("order/export", { order_id: order.id });
      const link = document.createElement("a");
      link.href = response.data.link;
      link.click();
      URL.revokeObjectURL(link.href);
      progressDialog.value = false;
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const exportOrders = async () => {
    try {
      if (!exportData.date.length) {
        toast.error(window.i18n["Please select a time frame"]);
        return true;
      }
      progressDialog.value = true;
      const range = exportData.date;
      let response = await axios.post("order/export/multi", {
        start_date: range[0],
        end_date: range.length > 1 ? range[1] : "",
        status: exportData.status,
      });
      const link = document.createElement("a");
      link.href = response.data.link;
      link.click();
      URL.revokeObjectURL(link.href);
      progressDialog.value = false;
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  return {
    errors,
    errorModal,
    meta,
    loading,
    orders,
    getOrderReturns,
    exportOrders,
    deleteOrder,
    getItemReturn,
    storeItemReturn,
    updateOrderReturn,
    returns,
    exportData,
    order,
    storeOrder,
    exportOrder,
    getOrders,
    getOrder,
    toast,
  };
}
